//SVATripperComponentEp
import React from 'react'
import {  Link } from "react-router-dom"

import { FieldArray,Field} from 'redux-form'

//import { SVADocComponentEp} from '../core'
//import { SVADocComponentEp } from './SVADocComponentEp'
import  SVADocComponentEp  from './SVADocComponentEp'
import {SVADeviceComponentEp} from './SVADeviceComponentEp'

const _ = require('lodash')





const normalizeNumber = value=>{

    let outValue = value
  
    if(!value){
        return outValue
    }
  
    const onlyNums = value.replace(/[^\d]/g, '')
  
    outValue = onlyNums
    console.log(onlyNums)
    return outValue
    //return outValue
  }
  
  
  const portTypes=[{
      key:'CL_Number',
      value:'number'
    },{
      key:'CL_String',
      value:'string'
    
    },{
      key:'CL_Date',
      value:'date'   
     
    }]
    
    const svtypes= ['single', 'double', 'complex']
    
    //inputSchemaType
  
  const holderTypes = [{
      name:'CL_Y',
      value:'Y'
    },{
      name:'CL_N',
      value:'N'
    
    }]
    const genderTypes = [{
      name:'CL_MALE',
      value:'MALE'
    },{
      name:'CL_FEMALE',
      value:'FEMALE'
    
    }] 
    const deviceTypes = [{
      name:'CL_MOBILE',
      value:'MOBILE'
    },{
      name:'CL_PAGER',
      value:'PAGER'
    
    }]
    
  const documentTypes = [{
      name:'CL_PASSPORT',
      value:'PASSPORT'
    },{
      name:'CL_IDENTITY_CARD',
      value:'IDENTITY_CARD'
    
    }]
    const inputSchemaTypes = [{
      name:'JSON',
      value:'JSON'
    },{
      name:'XML',
      value:'XML'
    },{
      name:'SVG',
      value:'SVG'
    }]
    const locationTypes = [{
        name:'START',
        value:'START'
    },{
        name:'CARRIER',
        value:'CARRIER'
    },{
        name:'END',
        value:'END'
    }]
    const transformToBA =(values)=>{
      let data ={
          id: values.id ||'addLeft_STEP',
          gene: values.gene ||'addLeft_STEP',
          lastName:'add_step',
          portType:'number',
          portInput :10,
          location:'START'
         
      
      }
    
     let members = values.members
    let  o ={
      id:data.id,
      inputPorts:['portA', 'portB'],
      gene:data.gene,
      location:data.location,
      input:{
          bindingType:'json',
          portA:{
              input:data.portInput,
              type:data.portType
    
          },
          portB:{
              input:20,
              type:'number'
    
          }
      }
    }  
    let   portResolved = _.findWhere(members, {portName:'portA'})
    if(portResolved){
      o.input['portA']= {
        input:portResolved.portInput,
        type: portResolved.portType
      }
      
    
    }
    
    portResolved = _.findWhere(members, {portName:'portB'})
    if(portResolved){
      o.input['portB']= {
        input:portResolved.portInput,
        type:portResolved.portType
      }
    
    }
    
    
    return o
    
    
    
    }
    let data ={
        id:'addLeft_STEP',
        gene:'addLeft_STEP',
        lastName:'add_step',
        portType:'number',
        portInput :10,
        location:'START'
    }
  
  
    const renderMembersPHone=(o)=>{
      const {fields, meta:{error, submitFailed}} =o
      let memphones =[
        {
            
            "deviceType": "MOBILE",
            "countryCallingCode": "34",
           
            
            "number": "480080085"
        },
        {
            
          "deviceType": "PAGER",
          "countryCallingCode": "34",
         
          
          "number": "480080087"
      }
    ]
      console.log(o)
       console.log('renderMembersPHone should generate empty object')
      // let fields = members
         console.log(fields)
       return(<ul>
    
           <li>
           <button type="button" onClick={()=>{ fields.push()}}  className="btn btn-md btn-success" > Add Device </button>
           { submitFailed && error && <span>{error} </span>}
           </li>
           {
                fields.map((member, index) => {
                    console.log(o)
                    
                   return(
                   <li key={index}>
                     <button
                       type="button"
                       className="btn btn-default"      
                       onClick={() => fields.remove(index)}
                     >Remove</button>
                     <h4>Device #{index + 1}</h4>
                      <SVADeviceComponentEp deviceTypes={deviceTypes} member={member} index={index} />
                   </li>
                 )})
    
           }
          
          
    
           </ul> )
          
    }
  const renderMembersPort=(o)=>{
      const {fields, meta:{error, submitFailed}} =o
      let members =[
          {
            "documentType": "IDENTITY_CARD",
            "birthPlace": "Madrid",
            "issuanceLocation": "Madrid",
            "issuanceDate": "2015-04-13",
            "documentNumber": "00000069",
            "expiryDate": "2025-04-13",
            "issuanceCountry": "ES",
            "validityCountry": "ES",
            "nationality": "ES",
            "holder": "Y"
          }
        ]
      console.log(o)
       console.log('renderMembers should generate empty object')
      // let fields = members
         console.log(fields)
       return(<ul>
    
           <li>
           <button type="button" onClick={()=>{ fields.push()}}  className="btn btn-md btn-success" > Add Port </button>
           { submitFailed && error && <span>{error} </span>}
           </li>
           {
                fields.map((member, index) => {
                    console.log(o)
                    
                   return(
                   <li key={index}>
                     <button
                       type="button"
                       className="btn btn-default"
                      
                       onClick={() => fields.remove(index)}
                     >Remove</button>
                     <h4>Port #{index + 1}</h4>
                    
                      <SVADocComponentEp holderTypes={holderTypes} documentTypes={documentTypes} inputSchemaTypes={inputSchemaTypes} locationTypes={locationTypes}  portTypes={portTypes} member={member} index={index} />
                     
                      
                    
                   </li>
                 )})
    
           }
          
          
    
           </ul> )
          
    }
    
    const getPortValue = (key)=>{
      let o = _.findWhere(portTypes, {key:key})
      return o.value
    }
  const renderField = ({
      input,
      label,
      type,
      meta: { asyncValidating, touched, error }
    }) => (
      
       
        
        <div className={asyncValidating ? 'async-validating' : ''}>
            
          <input className="form-control" {...input} type={type} placeholder={label} />
          {touched && error && <span className="sv-form-err" >{error}</span>}
        </div>
     
    )
  
    let dcountries = [{
      name:'United States Of America',
      value:'usa'
  
    },{
      name:'France',
      value:'France'
    },{
  
      name:'China',
      value:'China'
  },{
      name:'Mexico',
      value:'Mexico'
    
    }]
  
  
  let genes = [{
      name:'add_step',
      value:'add_step'
  
    },{
      name:'multiply_seq_step',
      value:'multiply_seq_step'
    },{
  
      name:'sq_step',
      value:'sq_step'
  },{
      name:'sr_step',
      value:'sr_step'
    
    }]
  
  
    let validate =(formData)=>{
      console.log('sv--valudare fprmData')
        console.log(validate)
          const errors={}
          if(!formData){
              console.log('validate: sv formData null issue')
              console.log(errors)
              return errors
          }
         
          if(!formData.isdcode){
              errors.isdcode= 'Required'
          }
        
         console.log('FlyPaymentDEtailFormBusCom validate error *************')
          console.log(errors)
          return errors
      
      }
      
      let warn= (formData)=>{
          const o = {}
          if(!formData){
              console.log('sv gene null issue')
              return o
          }
         
          return o
      }
export class SVATripperComponentEp extends React.Component{

    constructor(props){
        super(props)
        this.svfieldType=  this.props.portType || 'CL_String'
        this.state={
            svfieldType: this.props.portType || 'CL_String'
        }
       
        this.loadGene = this.loadGene.bind(this)
        this.ddChange = this.ddChange.bind(this) 
        /*
        this.getAppDetails = this.getAppDetails.bind(this)
        */
       
    }
    loadGene(e){
        console.log(e)
    }
    ddChange(e){
        
        console.log(e)
        console.log('gene name:' +this.props.gene)

        let o = _.findWhere(genes,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             gene:o.name
        })
        //load geneBus Componnet initialValues and form will reinitalize

    }
    componentWillReceiveProps(next){
        console.log(next)

    }
    render(){
        console.log('**sv Nov6... SVATrippercomponentWp')
        let me = this
        console.log(this.props)
        const {member, index}= this.props

        return (
            <div className="rev-row">
                            <div className="card card--raised with-shadow">
                                               
                                                
                                              <div className="form-group">
                                                    <label htmlFor={`${member}.tid`}> tid</label>
                                                    
                                                        <Field
                                                        normalize={normalizeNumber} 
                                                            id={`${member}.tid`}
                                                            name={`${member}.tid`}
                                                           
                                                            type="text"
                                                            placeholder=""
                                                            component="input"
                                                            className="form-control"
                                                        />
                                                    

                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor={`${member}.lastName`}> lastName</label>
                                                    
                                                        <Field
                                                    
                                                            id={`${member}.lastName`}
                                                            name={`${member}.lastName`}
                                                            
                                                            type="text"
                                                            placeholder="svinfinity"
                                                            component="input"
                                                            className="form-control"
                                                        />
                                                    

                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor={`${member}.firstName`}> First Name</label>
                                                    
                                                        <Field
                                                    
                                                       
                                                        id={`${member}.firstName`}
                                                        name={`${member}.firstName`}
                                                            placeholder="SV"
                                                            component="input"
                                                            className="form-control"
                                                        />
                                        
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor={`${member}.emailAddress`}> emailAddress</label>
                                                    
                                                        <Field
                                                    
                                                       
                                                           
                                                            id={`${member}.emailAddress`}
                                                            name={`${member}.emailAddress`}
                                                            type="text"
                                                            placeholder="sv@sv.com"
                                                            component="input"
                                                            className="form-control"
                                                        />
                                        
                                                </div>
                                                <div className="form-group">
                                                                <label htmlFor={`${member}.gender`}  > Gender</label>
                                                                <Field  component="select" id={`${member}.gender`}  name={`${member}.gender`} className="form-control" >
                                                                    <option value="">Select Gender</option>
                                                                    {

                                                                        genderTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                                                            
                                                                
                                                                )}
                                                        
                                                                </Field>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor={`${member}.dateOfBirth`}> dateOfBirth</label>
                                                    
                                                        <Field
                                                    
                                                    id={`${member}.dateOfBirth`}
                                                    name={`${member}.dateOfBirth`}
                                                            type="text"
                                                            placeholder="1982-01-15"
                                                            component="input"
                                                            className="form-control"
                                                        />
                                        
                                                </div>
                                                <div className="o-container-fpplist">
                                                      
                                                    <div className="o-box-fpplist-b1">
                                                        <FieldArray name="members" component={renderMembersPort} />
                                                                                      
                                                        
                                                      </div>
                                                      <div className="o-box-fpplist-b1">
                                                        <FieldArray name="memphones" component={renderMembersPHone} />
                                                  
                                                      </div>
                                                </div>
                                                {/*  
                                                <div className="o-container-fpplist">
                                                      <div className="o-box-fpplist-b1">
                                                        <FieldArray name="members" component={renderMembersPort} />
                                                                                      
                                                        
                                                      </div>
                                                      <div className="o-box-fpplist-b1">
                                                        <FieldArray name="memphones" component={renderMembersPHone} />
                                                  
                                                      </div>
                                                </div>
                                                */}
                    </div>
            </div>
                                               
                                        
                                               
                                            
                                            
                                        

        )
    }

}